module.exports = __webpack_public_path__ + "static/media/youtube_image.a2913e63.jpg";